import api from './api';
import { EventDefinition, EventCategory, PaginatedResponse } from '../types';

export interface EventDefinitionFilters {
  search?: string;
  category?: EventCategory;
}

export interface CreateEventDefinitionRequest {
  name: string;
  description?: string;
  category: EventCategory;
  config?: Record<string, unknown>;
  tagIds?: string[];
}

export interface UpdateEventDefinitionRequest {
  name?: string;
  description?: string;
  category?: EventCategory;
  config?: Record<string, unknown>;
  /** If provided, replaces the full set of tags on the event definition. */
  tagIds?: string[];
}

export const eventDefinitionService = {
  list: async (
    page = 1,
    pageSize = 100,
    filters?: EventDefinitionFilters,
  ): Promise<PaginatedResponse<EventDefinition>> => {
    const params: Record<string, unknown> = { page, page_size: pageSize };
    if (filters?.search) params.search = filters.search;
    if (filters?.category) params.category = filters.category;
    const response = await api.get<PaginatedResponse<EventDefinition>>(
      '/event-definitions',
      { params },
    );
    return response.data;
  },

  get: async (id: string): Promise<EventDefinition> => {
    const response = await api.get<EventDefinition>(`/event-definitions/${id}`);
    return response.data;
  },

  create: async (data: CreateEventDefinitionRequest): Promise<EventDefinition> => {
    const response = await api.post<EventDefinition>('/event-definitions', data);
    return response.data;
  },

  update: async (
    id: string,
    data: UpdateEventDefinitionRequest,
  ): Promise<EventDefinition> => {
    const response = await api.put<EventDefinition>(`/event-definitions/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/event-definitions/${id}`);
  },
};
